<template>
	<Form ref="formValidate" :model="formValidate"  :label-width="110":label-colon="true">
		<Row>
			<Col :md="8" :sm="8" :xs="8">
			<FormItem label="状态">
				<Select v-model="formValidate.status" clearable>
					<Option value="1">已完成</Option>
					<Option value="2">待审核</Option>
					<Option value="3">审核拒绝</Option>
					<Option value="4">提现失败</Option>
				</Select>
			</FormItem>
			</Col>
			<Col :md="16" :sm="16" :xs="16">
			<FormItem>
				<Button type="primary" @click="formSubmit" icon="md-search"style="margin: 0 8px 16px 16px;">查询</Button>
				<Button type="default" @click="formReset" style="margin: 0 8px 16px 16px;">重置</Button>
			</FormItem>
			</Col>
		</Row>
	</Form>
</template>
<script>
	import api from '../../api'
	import { mapGetters } from 'vuex'
	import { STATISTICS_START_TIME, LINK_TYPES, ADVERT_TYPES } from '../../config/constants'

	export default {
		name: 'QueryCondition',
		props: {
			showPageStatus: {
				type: Boolean,
				default: true
			}
		},
		data() {
			return {
				appStores: [],
				linkTypes: LINK_TYPES,
				advetTypes: ADVERT_TYPES,
				formValidate: {
					status: '',
				},
				dateRangeOptions: {
					//当前日期之后日期为禁选日期
					disabledDate(date) {
						const startDate = new Date(STATISTICS_START_TIME).getTime()
						const now = Date.now()
						return (
							date && !(date.valueOf() >= startDate && date.valueOf() <= now)
						)
					}
				}
			}
		},
		computed: {
			...mapGetters('statistics', ['accountGroup', 'pageStatus'])
		},
		mounted() {
			this.getAllAppStore()
		},
		methods: {
			getAllAppStore() {
				api.statistics
					.getAllUsedStores()
					.then(res => {
						this.appStores = res.data
					})
			},
			formSubmit() {
				this.$emit('query', this.getFormData())
			},
			exportExcel(){
				this.$emit('exportExcel', this.getFormData())
			},
			formReset() {
				this.$refs['formValidate'].resetFields()
				this.formValidate = {
					dateRange: [],
				}
				this.formSubmit()
			},
			getFormData() {
				const formData = { ...this.formValidate }
				return formData
			}
		}
	}
</script>
